import { Form, Button, Space, Popconfirm } from 'antd'
import { useCIMSNotificationsContext } from '../../../CIMSNotificationsContext'
import { useEffect, useState } from 'react'
import { NotificationEventItem } from 'shared'
import { useCIMSNotificationsPanelContext } from '../../CIMSNotificationsPanelContext'
import { useCheckPermissions } from 'hooks/useCheckPermission'
import CIMSDivider from '../../../../CIMSDivider'
import { Store } from 'antd/lib/form/interface'

function EditContent<T extends NotificationEventItem, U extends Store>() {
  const { event, form } = useCIMSNotificationsPanelContext<T>()
  const { edit, loading, __debug, onReload } = useCIMSNotificationsContext<
    T,
    U
  >()
  const { initialValues, onSave, render, permission, onClear } = edit(event)
  const [saving, setSaving] = useState(false)
  const can = useCheckPermissions(event)
  if (__debug) {
    console.groupCollapsed('EditContent')
    console.log('initialValues', initialValues)
    console.log('permission', { can: can(permission), permission })
    console.groupEnd()
  }
  /**
   * Recipients weren't updating on Project change, so we have to do this
   * to force form values to update when initialValues change
   *
   * form.resetFields replaces current form values with initialValues
   *
   * This causes a memory leak error (sometimes?), but we're okay with it for now
   * {@link https://github.com/ant-design/ant-design/issues/22683#issuecomment-1790395742}
   */
  useEffect(() => form.resetFields(), [form, initialValues])
  return (
    <Form
      form={form}
      initialValues={initialValues}
      onFinish={async (values) => {
        try {
          setSaving(true)
          await onSave(values)
        } finally {
          setSaving(false)
        }
      }}
    >
      {render}
      <CIMSDivider />
      <Space size="large">
        <Button
          loading={saving || loading}
          disabled={saving || loading}
          type="primary"
          onClick={() => form.submit()}
        >
          Save
        </Button>
        <Button onClick={() => form.resetFields()}>Undo</Button>
        <Popconfirm
          key={event.id}
          title={`Are you sure you want to remove all recipients for the ${event.name} event? This action cannot be undone!`}
          onConfirm={async () => {
            await onClear()
            await onReload()
            form.resetFields()
          }}
        >
          <Button>Clear</Button>
        </Popconfirm>
      </Space>
    </Form>
  )
}

export default EditContent
